import React, { useState, useRef, useEffect, } from "react";
import { Link, useNavigate } from "react-router-dom";
import Form from "react-validation/build/form";
import CurrencyInput from "react-currency-input-field";
import Tooltip from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import { useForm } from "react-hook-form";
import { ToastContainer, toast } from 'react-toastify';
import CheckButton from "react-validation/build/button";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import Helper from "../../../Helper";
import ButtonLoading from "../../../components/Loder/buttonLoading";
import { getTrans as t } from "../../../Localization/translations"
import AddItemmasterService from "../../../services/itemmaster/itemmasterAddService";
import AddcategoryService from "../../../services/category/categoryAddServices";

function Itemmasteradd() {

  let navigate = useNavigate();
  const [itemid, setItemID] = useState("")
  const [itemname, setItemName] = useState("")
  const [quantity, setQuantity] = useState("1")
  const [quantityError, setQuantityError] = useState("")
  const [serialRows, setSerialRows] = useState([{ serial_number: "" }])
  const [description, setDescription] = useState("")
  const [life_in_months, setLife_in_Months] = useState(0)
  const [netbookvalue, setNetBoolValue] = useState(0)
  const [originalcost, setOriginal_Cost] = useState("")
  const [date_place, setDate_place] = useState(null)
  const [year, setYear] = useState(null);
  const [make, setMake] = useState(null);
  const [model, setModel] = useState(null);
  const [manufacturer, setManufacturer] = useState(null);
  const [status, setStatus] = useState("Inventory")
  const [category_list, setCategory_list] = useState([])
  const [sub_categories, setSub_categories] = useState([])
  const [selected_category, setSelected_category] = useState("")
  const [selected_sub_category, setselected_sub_category] = useState("")
  const [asset_type, setAsset_type] = useState("")

  const checkBtn = useRef();
  const { register, handleSubmit,setValue, reset, formState: { errors } } = useForm();
  const form = useRef();

  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(false);


  const dateplace_Date = (value) => {
    setDate_place(value)
    reset({
      Dateplaced: value
    })
  }

  const handleQuantityChange = (e) => {
    const rawValue = e.target.value;
    setQuantity(rawValue);

    const value = parseInt(rawValue, 10);
    if (rawValue === "" || isNaN(value) || value < 1) {
      setQuantityError(t("Quantity must be at least 1"));
      return;
    }

    setQuantityError("");
    setSerialRows((prevRows) => {
      const rows = [...prevRows];
      if (value > rows.length) {
        while (rows.length < value) {
          rows.push({ serial_number: "" });
        }
      } else {
        rows.length = value;
      }
      return rows;
    });
  };

  const handleSerialNumberChange = (index, value) => {
    setSerialRows((prevRows) => {
      const rows = [...prevRows];
      rows[index] = { ...rows[index], serial_number: value };
      return rows;
    });
  };

  const handleRegister = () => {
    setLoading(true)
    setDisable(true)
    form.current.validateAll();
    let Date = null;
    let item_type = asset_type
    if (checkBtn.current.context._errors.length === 0) {
      if (date_place) {
        Date = Helper.DatePicker(date_place)
      }
      else {
        setDate_place(date_place)
      }
      let asset_id = null
      let category_id = selected_category !== "" ? selected_category : ""
      let sub_category_id = selected_sub_category !== "" ? selected_sub_category : ""

      const quantityValue = parseInt(quantity, 10);
      if (quantityError || isNaN(quantityValue) || quantityValue < 1) {
        toast.error("Please enter a valid Quantity (1 or more)", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        })
        setLoading(false)
        setDisable(false)
        return false
      }

      AddItemmasterService.addItemmaster(
        itemid,
        itemname,
        description,
        serialRows[0]?.serial_number || "",
        year,
        manufacturer,
        model,
        make,
        Date,
        life_in_months,
        netbookvalue,
        originalcost,
        status,
        asset_id,
        item_type,
        category_id,
        sub_category_id,
        quantityValue,
        serialRows.map((row) => ({ serial_number: row.serial_number }))
      ).then(
        (response) => {
          if (response.data.success === 1) {
            toast.success(`${response.data.response}`, {
              position: "top-right",
              autoClose: 1000,
              hideProgressBar: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            })
            setLoading(false)
            setTimeout(() => {
              setDisable(false)
              navigate("/itemmaster")
            }, 2000)
          }
          else {
            setLoading(false)
            setDisable(false)
            toast.error(`${response.data.error}`, {
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            })
          }
        },
      )
    }
  }


  useEffect(() => {
    AddcategoryService.viewListCategory().then((response) => {
      setCategory_list(response.data.data.categories);
    });
  }, []);

  const handleCategoryChange = (e) => {
    const selectedValue = e.target.value;
    setSelected_category(selectedValue);
    handleItemType(selectedValue)
  }

  const handleItemType = (selectedValue) =>{
    const itemval = category_list.find((val) =>  val.id === parseInt(selectedValue))
    console.log(itemval?.item_type)
    if (itemval) {
      setAsset_type(itemval.item_type);
      setValue("item_type", itemval.item_type);
    } else {
      setAsset_type('');
      setValue("item_type", '');
    }
  }

  useEffect(() => {
    if (selected_category !== "") {
      const matchedCategory = category_list.find(
        (cat) => cat.id === Number(selected_category)
      )
      const category_name = matchedCategory.category_name;
      const item_types = matchedCategory?.item_type
      AddcategoryService.filtersubCategory(category_name).then((response) => {
        const fetchedSubCategories = response.data.sub_categories;
        setSub_categories(fetchedSubCategories);
        const defaultSubCategory = fetchedSubCategories.find(subCat => subCat.is_default === true);
        if (defaultSubCategory) {
          setselected_sub_category(defaultSubCategory.id.toString());
          reset({
            subcategory:defaultSubCategory.id
          })
        } else {
          setselected_sub_category("");
        }
      });
      reset({
        item_type:item_types
      })
    }
  }, [selected_category, category_list])

  const handlesubCategoryChange = (e) => {
    const selectedValue = e.target.value;
    setselected_sub_category(selectedValue);
  }

  return (
    <>
      <div>
        <div className="container-fluid pt-2 ">
          <ToastContainer />
          <div className="header pb-0 mb-3">
            <h5>{t('Item Add')}</h5>
          </div>
          <div className="card" role="document">
            <div className="card-body">
              <div className="row">
                <Form role="form text-left"
                  onSubmit={handleSubmit(handleRegister)}
                  ref={form}
                  action="."
                  method="POST"
                  id="addPartyForm" >
                  {(
                    <>
                      <div className="form-group row">
                        <div className="col-sm-6">
                          <label className="col-form-label">
                            {t('Item Number')}  <Tooltip content={t("ItemName_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip>
                          </label>
                          <input
                            placeholder={t('Item Number')}
                            className="form-control"
                            type="text"
                            name="itemname"
                            disabled
                            id="itemname"
                            {...register("itemname", { onChange: (e) => { setItemName(e.target.value) }, required: false })}
                          />
                          {/* <div className="invalid-feedback">
                          {errors.itemname?.type === 'required' && "Item Name  is required"}
                        </div> */}
                        </div>
                        <div className="col-sm-6">
                          <label className="col-form-label required">{t('Item Type')} <Tooltip content={t('ItemType_Tooltip')}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                          <select
                            className="form-control"
                            name="item_type"
                            disabled
                            value={asset_type}
                            {...register("item_type", { required: false })}
                            // onChange={(e) => setAsset_type(e.target.value)}
                            // {...register("item_type", { onChange: (e) => { setAsset_type(e.target.value) }, required: true })}
                          >
                            <option value="">Select Value</option>
                            <option value="Vehicle">Vehicle</option>
                            <option value="Equipment">Equipment</option>
                          </select>
                          {/* <div className="invalid-feedback">
                            {errors.item_type?.type === 'required' && "Item Type  is required"}
                          </div> */}
                        </div>
                      </div>
                      <div className="form-group row">
                        <div className="col-sm-6">
                          <label className="col-form-label required">
                            {t('Description')}  <Tooltip content={t('Description_Tooltip')}><i className="fa fa-light fa-circle-info"></i></Tooltip>
                          </label>
                          <input
                            className="form-control"
                            placeholder="Description"
                            name="description"
                            type="text"
                            {...register("description", { onChange: (e) => { setDescription(e.target.value) }, required: true })}

                          // onChange={(e) => setDescription(e.target.value)}
                          />
                          <div className="invalid-feedback">
                            {errors.description?.type === 'required' && "Description  is required"}
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <label className="col-form-label required">{t('Status')} <Tooltip content={t('Status_Tooltip')}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                          <select
                            className="form-control"
                            name="status"
                            onChange={(e) => setStatus(e.target.value)}
                            {...register("status", { onChange: (e) => { setStatus(e.target.value) }, required: true })}
                          >
                            <option value="Inventory">Inventory</option>
                            <option value="Available for Lease">Available for Lease</option>
                            <option value="Available for Rent">Available for Rent</option>
                            <option value="Available for Sale">Available for Sale</option>
                            <option value="Scrapped">Scrapped</option>
                          </select>
                          <div className="invalid-feedback">
                            {errors.status?.type === 'required' && "Status  is required"}
                          </div>
                        </div>
                      </div>
                      <div className="form-group row">
                        <div className="col-sm-6">
                          <label className="col-form-label required">{t('Category')} <Tooltip content={t('Category_Tooltip')}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                          <select
                            className="form-control"
                            name="category"
                            // onChange={(e)=>{handleCategoryChange(e)}}
                            {...register("category", { onChange: (e) => { handleCategoryChange(e) }, required: true })}
                            value={selected_category}
                          >
                            <option value="">Select Category</option>
                            {category_list.map((val, i) => (
                              <option key={i} value={val.id}>
                                {val.category_name}
                              </option>
                            ))}
                          </select>
                          <div className="invalid-feedback">
                            {errors.category?.type === 'required' && "Category  is required"}
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <label className="col-form-label required">{t('Sub Category')} <Tooltip content={t('Sub_category_Tooltip')}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                          <select
                            className="form-control"
                            name="subcategory"
                            value={selected_sub_category}
                            {...register("subcategory", { onChange: (e) => { handlesubCategoryChange(e) }, required: true })}
                          >
                            <option value="">Select Subcategory</option>
                            {sub_categories.map((val) => (
                              <option key={val.id} value={val.id}>
                                {val.sub_category_name}
                              </option>
                            ))}
                          </select>
                          <div className="invalid-feedback">
                            {errors.subcategory?.type === 'required' && "Subcategory  is required"}
                          </div>
                        </div>
                      </div>
                      <div className="form-group row">
                        <div className="col-sm-6">
                          <label className="col-form-label required">{t('Net Book Value')} <Tooltip content={t('NetBookValue_Tooltip')}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                          <CurrencyInput
                            id="input-example"
                            {...register("netbookvalue", {
                              required: 'Net Book Value is required',
                              validate: (value) => {
                                const numericValue = parseFloat(value) || 0;
                                return numericValue > 0 || "Net Book Value must be greater than 0";
                              }
                            })}
                            name="netbookvalue"
                            allowDecimals="false"
                            value={netbookvalue}
                            onValueChange={(value) => setNetBoolValue(value)}
                            className="form-control"
                            disableAbbreviations
                          />
                          <div className="invalid-feedback">
                            {errors.netbookvalue?.message}
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <label className="col-form-label required">{t('Original Cost')} <Tooltip content={t('OriginalCost_Tooltip')}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                          <CurrencyInput
                            id="input-example"
                            className="form-control"
                            {...register("originalcost", {
                              required: "Original Cost is required",
                              validate: (value) => {
                                const numericValue = parseFloat(value) || 0;
                                return numericValue > 0 || "Original Cost must be greater than 0";
                              }
                            })}
                            allowDecimals="false"
                            value={originalcost}
                            onValueChange={(value) => setOriginal_Cost(value)}
                            name="originalcost"
                            disableAbbreviations
                          />
                          <div className="invalid-feedback">
                            {errors.originalcost?.message}
                          </div>
                        </div>
                      </div>
                      <div className="form-group row">
                        <div className="col-sm-6">
                          <label className="col-form-label required">{t('Quantity')} <Tooltip content={t('Quantity_Tooltip')}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                          <input
                            value={quantity}
                            onChange={handleQuantityChange}
                            type="number"
                            min="1"
                            name="quantity"
                            id="quantity"
                            className="form-control"
                          />
                          {quantityError && (
                            <div className="invalid-feedback d-block">{quantityError}</div>
                          )}
                        </div>
                        <div className="col-sm-6">
                          <label className="col-form-label">{t('Year of Manufacture')} <Tooltip content={t('YearofManufacturer_Tooltip')}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                          <input
                            value={year}
                            onChange={(e) => setYear(e.target.value)}
                            type="text"
                            id="year"
                            className="form-control"
                            placeholder="Year"
                          />
                        </div>
                      </div>
                      <div className="table-responsive">
                        <table className="table table-nowrap mb-0" style={{ maxWidth: "300px" }}>
                          <thead>
                            <tr>
                              <th style={{ color: "#245C7F" }}>{t("Serial Number")} <Tooltip content={t("SerialNumber_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                              serialRows.map((row, index) => (
                                <tr key={index}>
                                  <td>
                                    <input
                                      value={row.serial_number}
                                      onChange={(e) => handleSerialNumberChange(index, e.target.value)}
                                      type="text"
                                      className="form-control" />
                                  </td>
                                </tr>
                              ))
                            }
                          </tbody>
                        </table>
                      </div>
                      <div className="form-group row">
                        <div className="col-sm-6">
                          <label className="col-form-label">{t('Manufacturer')} <Tooltip content={t("Manufacturer_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                          <input
                            value={manufacturer}
                            onChange={(e) => setManufacturer(e.target.value)}
                            type="text"
                            id="manufacturer"
                            className="form-control"
                            placeholder="Manufacturer"
                          />
                        </div>
                        <div className="col-sm-6">
                          <label className="col-form-label">{t('Model')} <Tooltip content={t('Model_Tooltip')}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                          <input
                            value={model}
                            onChange={(e) => setModel(e.target.value)}
                            type="text"
                            name="Model"
                            id="model"
                            className="form-control"
                            placeholder="Model"
                          />
                        </div>
                      </div>

                      <div className="form-group row">
                        <div className="col-sm-6">
                          <label className="col-form-label">{t('Make')} <Tooltip content={t('Make_Tooltip')}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                          <input
                            value={make}
                            onChange={(e) => setMake(e.target.value)}
                            type="text"
                            id="make"
                            className="form-control"
                            placeholder="Make"
                          />
                        </div>
                        <div className="col-sm-6">
                          <label className="col-form-label">{t('Date placed in Service')} <Tooltip content={t('DateplacedinService_Tooltip')}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                          <DatePicker

                            className="form-control datepick"
                            selected={date_place}
                            onChange={(e) => dateplace_Date(e)}
                            placeholderText={"mm/dd/yyyy"}
                            scrollableYearDropdown
                            showMonthDropdown
                            showYearDropdown
                            scrollableMonthYearDropdown
                            dropdownMode="select"
                          />

                        </div>
                      </div>

                      <div className="form-group row">
                        <div className="col-sm-6">
                          <label className="col-form-label">{t('Life in Months')} <Tooltip content={t('LifeinMonths_Tooltip')}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                          <input
                            placeholder={t('Life in Months')}
                            className="form-control"
                            type="text"
                            value={life_in_months}
                            onChange={(e) => setLife_in_Months(e.target.value)}
                            name="life_in_months"
                            maxLength="100"
                            id="id_life_in_months"
                          />
                        </div>
                      </div>
                      <div className="text-left  py-4 ">
                        <Link to={"/itemmaster"}>
                          <button type="button" className="btn btn-secondary btn-md">{t('Cancel')}</button>&nbsp;&nbsp;
                        </Link>
                        <button type="submit" disabled={disable} className="border-0 btn btn-primary btn-gradient-primary btn-md">
                          {
                            loading === false ? (
                              t('Save')
                            ) : (
                              <ButtonLoading />
                            )
                          }
                        </button>&nbsp;&nbsp;
                      </div>
                    </>
                  )}
                  <CheckButton style={{ display: "none" }} ref={checkBtn} />
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Itemmasteradd
